import heading from "./components/heading";
import text from "./components/text";
import { gradients } from "./foundations/color";
import { mapGradient } from "./utils/mapGradient";

const globalStyle = {
    global: () => ({
        body: {
            fontFamily: "body",
            color: "black",
        },
        svg: {
            width: "1rem",
            height: "1rem",
        },
        ".richtext": {
            "h1,h2,h3,h4,h5,h6,blockquote,p,ul,ol": {
                ":first-child": {
                    mt: "0",
                },
            },
            "h1,h2": {
                ...heading.sizes?.h2,
                mt: "sp128",
                mb: "sp56",
            },
            "h3, h4, h5": {
                ...text.sizes?.body,
                mt: "sp36",
                mb: "sp16",
            },
            "h6, blockquote": {
                ...heading.sizes?.h5,
                my: "sp40",
                _before: {
                    content: `'“'`,
                },
                _after: {
                    content: `'”'`,
                },
                bgGradient: mapGradient(gradients.purpleToOrange),
                bgClip: "text",
                color: "transparent",
            },
            p: {
                ...text.sizes?.bodySmall,
                marginBottom: "1rem",
                strong: {
                    fontWeight: "700",
                },
                em: {
                    fontStyle: "italic",
                },
            },
            a: {
                textDecoration: "underline",
                cursor: "pointer",
                outline: "none",
                wordBreak: "break-word",
                _focus: {
                    textDecoration: "underline dotted",
                },
                _hover: {
                    outline: "none",
                    textDecoration: "none",
                },
            },
            "ul, ol": {
                ml: "18",
                ...text.sizes?.bodySmall,
                "> li": {
                    ml: "sp8",
                    lineHeight: "tall",
                    mb: "1em",
                    strong: {
                        fontWeight: "700",
                    },
                    em: {
                        fontStyle: "italic",
                    },
                },
            },
            strong: {
                fontWeight: "normal",
            },
            em: {
                fontStyle: "normal",
            },
        },
    }),
};

export default globalStyle;
